import { ChartArea, FontSpec } from 'chart.js';
import { renderText, toFont } from 'chart.js/helpers';
import { Palette } from '@infoods/lifebase-ui';

type DrawLabelOptions = {
  label: string[];
  pointX: number;
  gapFromChartArea: number; // control position like general labels
  color: string;
  font: Partial<FontSpec>;
};

export const drawLabel = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
  options: DrawLabelOptions,
  palette: Palette,
) => {
  const { bottom } = chartArea;
  const { label, pointX, gapFromChartArea, color } = options;
  const font = toFont(options.font);

  const maxWidth = Math.max(...label.map((line) => ctx.measureText(line).width));

  const rectPadding = 4;
  const rectWidth = maxWidth + rectPadding * 2;

  const labelY = bottom + gapFromChartArea;
  const labelX = pointX;

  ctx.save();
  ctx.fillStyle = palette.white;
  ctx.fillRect(
    labelX - rectWidth / 2, // center the text
    labelY - font.lineHeight / 2, // start in the top of text
    rectWidth,
    bottom,
  );
  ctx.restore();

  renderText(ctx, label, labelX, labelY, font, {
    color,
    textAlign: 'center',
    textBaseline: 'middle', // necessary for several lines shows same as main label
  });
};
